import React from "react";
import { loadingsShow } from "../../Services/PostAPI";
import transactionsData from "./tableData.json";
import { APP_URLS } from "../../constants/urlConstants";
import { useHistory } from "react-router-dom";
import { generatePath } from "react-router-dom/cjs/react-router-dom.min";
import TruckCare from "../../components/TruckCare";

const TruckCareScreen = () => {
  // loader none for now------------
  setTimeout(() => loadingsShow('none'), 1000)

  const history = useHistory()

  const createTransaction = () => {
    history.push(APP_URLS.TRANSACTIONS.ADD_TRANSACTION);
  };

  const editTransaction = (transactionId) => {
    console.log(transactionId);
    const path = generatePath(APP_URLS.TRANSACTIONS.EDIT_TRANSACTION, {
    transactionId,
    });
    history.push(path);
  };
  const transactionProps = {
    createTransaction,
    editTransaction,
    ...transactionsData
  }


  return (
    <div>
      <TruckCare
      {... transactionProps}
      />
    </div>
  );
};

export default TruckCareScreen;
